(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/getters.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/getters.js');
"use strict";


const getCart = state => {
  const settings = state.settings,
    cart = state.cart;
  return cart[settings.branding] || {};
};
svs.tickets_giftshop.gift.giftform.cart.getters = {
  getCart
};

 })(window);